export const state = initialState();

// state is a function so it can be instantiated again - reset
function initialState() {
  return {};
}

export const getters = {
  activeSubscription(state) {
    return state.user.customer.subscriptions && state.user.customer.subscriptions.data.length > 0
      ? state.user.customer.subscriptions.data[0]
      : null;
  },
};

export const mutations = {
  reset(state) {
    // acquire initial state
    const s = initialState();
    Object.keys(s).forEach((key) => {
      state[key] = s[key];
    });
  },
};

export const actions = {};
